import {
    Box,
    Accordion,
    AccordionItem,
    AccordionButton,
    AccordionPanel,
    AccordionIcon,
    HStack,
    Grid,
    Progress,
    Skeleton,
    SkeletonCircle,
} from '@chakra-ui/react';
import { useSelector } from 'react-redux';
import DashboardHydrationCardSkeleton from './components/DashboardHydrationCardSkeleton';

const CARDS_PER_SECTION = 3;

const DashboardServicesSkeleton = ({ accordionSections = 5, ...props }) => {
    const { darkMode } = useSelector((state) => state.settings);
    const skeletonStartColor = darkMode ? 'whiteAlpha.200' : 'gray.100';
    const skeletonEndColor = darkMode ? 'whiteAlpha.300' : 'gray.300';
    const sections = Array.from({ length: accordionSections });

    return (
        <Box mb={6} {...props}>
            <Accordion
                defaultIndex={sections.map((_, index) => index)}
                allowToggle
                allowMultiple
                reduceMotion
                borderRadius="8px"
                mb={4}>
                {sections.map((_, sectionIndex) => (
                    <AccordionItem
                        key={`fallback-section-${sectionIndex}`}
                        borderRadius="8px"
                        borderTop="none"
                        borderBottom="none"
                        marginBottom={4}
                        bg="transparent">
                        {({ isExpanded }) => (
                            <>
                                <HStack spacing={0} position="relative">
                                    <AccordionButton
                                        flex="1"
                                        borderRadius={
                                            isExpanded ? '8px 8px 0 0' : '8px'
                                        }
                                        paddingTop={4}
                                        position="relative"
                                        height="61px"
                                        bg={darkMode ? 'dark.tcap' : 'white'}
                                        _hover={{
                                            bg: darkMode
                                                ? 'dark.tcap'
                                                : 'white',
                                        }}
                                        paddingBottom={5}>
                                        <Progress
                                            value={100}
                                            sx={{
                                                position: 'absolute',
                                                top: 0,
                                                left: 0,
                                                height: '100%',
                                                width: '10px',
                                                borderRadius: isExpanded
                                                    ? '8px 0 0 0'
                                                    : '8px 0 0 8px',
                                            }}
                                            colorScheme="gray"
                                            hasStripe
                                            isAnimated
                                        />
                                        <HStack
                                            spacing={3}
                                            flex="1"
                                            textAlign="left">
                                            <SkeletonCircle
                                                size="24px"
                                                startColor={skeletonStartColor}
                                                endColor={skeletonEndColor}
                                            />
                                            <Skeleton
                                                height="20px"
                                                width="140px"
                                                startColor={skeletonStartColor}
                                                endColor={skeletonEndColor}
                                            />
                                        </HStack>
                                        <Box
                                            as="span"
                                            flex="0"
                                            textAlign="right">
                                            <AccordionIcon />
                                        </Box>
                                    </AccordionButton>
                                </HStack>
                                {isExpanded && (
                                    <AccordionPanel
                                        pb={4}
                                        px={0}
                                        borderRadius="0 0 8px 8px"
                                        backgroundColor={
                                            darkMode ? '#000000' : 'white'
                                        }>
                                        <Grid
                                            margin="20px"
                                            templateColumns="repeat(2, 1fr)"
                                            gap={4}>
                                            {Array.from({
                                                length: CARDS_PER_SECTION,
                                            }).map((_, index) => (
                                                <DashboardHydrationCardSkeleton
                                                    key={`fallback-section-${sectionIndex}-card-${index}`}
                                                    animationDelayMs={
                                                        sectionIndex * 140 +
                                                        (index + 1) * 90
                                                    }
                                                />
                                            ))}
                                        </Grid>
                                    </AccordionPanel>
                                )}
                            </>
                        )}
                    </AccordionItem>
                ))}
            </Accordion>
        </Box>
    );
};

export default DashboardServicesSkeleton;
